import { FC } from 'react';
import { IModalConfirm } from '../../types';
import Button from '../form/button';
import ModalDefault from './default';
import ModalFooter from './footer';

const ModalConfirm: FC<IModalConfirm> = (props) => {

  const {
    isOpen,
    onClose,
    onConfirm,
    onCancel,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    children,
    ...rest
  } = props;

  return (
    <ModalDefault
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      contentProps={{
        style: {
          paddingBottom: '0',
        },
      }}
      {...rest}
    >

      {children}

      <ModalFooter>
        <div className="buttons">
          <Button
            onClick={onCancel || onClose}
          >
            {cancelText}
          </Button>
          <Button
            variant="dark"
            onClick={onConfirm}
          >

            {confirmText}
          </Button>
        </div>
      </ModalFooter>
    </ModalDefault>
  );

};

export default ModalConfirm;
